import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { S3, config } from 'aws-sdk';
import { saveAs } from 'file-saver';
import { DATETIME_FORMAT_FILE_PREFIX_S3 } from '../../utils/constant';
import * as moment from 'moment';
import * as _ from 'lodash';
import { HelperService } from '../helper/helper.service';
import { environment } from '../../../environments/environment';
import { Observable, of as observableOf} from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(
    private authService: AuthService,
    private helper: HelperService,
    private http: HttpService
  ) { }

  public download({ bucketName, key, filename }: {bucketName: string, key: string, filename?: string}, callback: (err?, data?: any) => void){
    this.authService.checkAWSCredentials( (err) => {
      if(err){
        return callback(err);
      }

      let bucket = new S3();

      let params = {
        Bucket: bucketName,
        Key: key,
      };

      bucket.getObject(params, (err, data) => {
        if(err){
          return callback(err);
        }
        saveAs(new Blob([data.Body as any], { type: data.ContentType }), filename);
        callback(null, data);
      });
    });
  }

  public upload(
      { folderName, file, options }: {folderName: string, file: File, options?: S3.ManagedUpload.ManagedUploadOptions}
    )
  {
    return new Observable((subsriber) => {
      this.authService.checkAWSCredentials( (err) => {
        if(err){
          subsriber.error(err);
          subsriber.complete()
        }
  
        let bucket = new S3({ region: environment.region });
  
        let extraPrefix = this.helper.randomString(6);
        // let kebabFilename = _.kebabCase(file.name);
        let now = moment().format(DATETIME_FORMAT_FILE_PREFIX_S3);
  
        let key = `${extraPrefix}-${now}-${file.name}`;
        let bucketName = folderName ? (environment.bucketName + '/' + folderName) : environment.bucketName;
  
        console.log(file)

        let params = {
          Bucket: bucketName,
          Key: key, 
          Body: file,
          ContentType: file.type
        };  
        console.log(params)
        bucket.upload(params, options, (err) => {
          if(err){
            subsriber.error(err);
            subsriber.complete()
          }
          subsriber.next(key);
          subsriber.complete()
        });
      });
    })
  }

  public uploadImageToPreSignedUrl(presignedUrl:string, image:File, fileKeyName:string){

    const imageFile = new File([image], fileKeyName, {type: image.type})

    return this.http.putSignedUrl(presignedUrl, imageFile)
  }
}
